const initialState = {

}

export default (state = initialState, action) => {
  switch (action.type) {
    case 'WORKFLOWS_OWNER_LIST_DONE': {
      const { collection: [owner] } = action.payload

      if (!owner) {
        return state
      }

      const { id, name, type } = owner

      return {
        ...state,
        ...{ id, name, type }
      }
    }
    case 'WORKFLOWS_OWNER_SET': {
      const { owner } = action.payload
      return { ...owner }
    }
    default:
      return state
  }
}
